import { render } from "./Title.vue?vue&type=template&id=45574662&scoped=true"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"

import "./Title.vue?vue&type=style&index=0&id=45574662&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45574662"

export default script